<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_v"></a>SECOND SKIN</h1>
<p class="sub-title"><em>A Nocturne City Novel</em></p>
<p class="author"><span class="small">CAITLIN KITTREDGE</span></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/publisher.jpg"/><br/>St. Martin’s Paperbacks</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?08a61912